'use client'

import { useStats } from 'react-instantsearch'

export default function FilterStats() {
  const { nbPages, page } = useStats()

  if (nbPages <= 1) {
    return null
  }

  return (
    <span className="text-14 ms:text-12 ms:text-grey-800">
      Showing page {page + 1} of {nbPages}
    </span>
  )
}
